"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuList = _interopRequireDefault(require("@mui/material/MenuList/MenuList.js"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon/ListItemIcon.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _MenuIcon = _interopRequireDefault(require("./MenuIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const styles = theme => ({
  active: {
    backgroundColor: `${theme.palette.primary.light} !important`,
    '& span': {
      color: theme.palette.primary.contrastText
    },
    '& svg': {
      color: theme.palette.primary.contrastText
    }
  },
  labelIcon: {
    height: '24px',
    width: '24px',
    lineHeight: '24px',
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  labelOption: {
    fontWeight: 600,
    textAlign: 'center' //some sort of type-script tom-foolery
  }
});
const SelectPopover = props => {
  const {
    items,
    PlaceHolderIcon,
    defaultValue,
    value,
    onChange,
    buttonProps,
    disabled,
    tooltip,
    iconProps,
    classes
  } = props;
  const [open, setOpen] = (0, _react.useState)(false);
  const [activeValue, setActiveValue] = (0, _react.useState)(defaultValue);
  (0, _react.useEffect)(() => {
    if (value) setActiveValue(value);
  }, [value]);
  const ActiveIcon = activeValue ? activeValue.Icon || (() => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classes.labelIcon,
    children: activeValue.label
  })) : PlaceHolderIcon;
  const activeIndex = items.indexOf(activeValue);
  const handleSelect = value => {
    setActiveValue(value);
    setOpen(false);
    if (onChange) onChange(value);
  };
  const renderIcon = ({
    Icon,
    label
  }) => {
    const DisplayIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {});
    return label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
      className: classes.labelIcon,
      children: DisplayIcon
    }) : DisplayIcon;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuIcon.default, {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(ActiveIcon, {
      ...iconProps
    }),
    open: open,
    disabled: disabled,
    tooltip: tooltip,
    onClick: () => setOpen(true),
    onClose: () => setOpen(false),
    noPadding: true,
    buttonProps: buttonProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuList.default, {
      children: items.map((item, i) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
          onClick: () => {
            handleSelect(item);
          },
          disabled: item.disabled,
          className: i === activeIndex ? classes.active : '',
          "data-cy": "dropdown-option",
          children: [item.Icon && renderIcon({
            Icon: item.Icon,
            label: item.label
          }), item.label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
            classes: {
              primary: (0, _classnames.default)({
                [classes.labelOption]: !item.Icon
              })
            },
            children: item.label
          })]
        }, `${item.label}-${item.value}`);
      })
    })
  });
};
var _default = exports.default = (0, _withStyles.default)(styles)(SelectPopover);